import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {NgForm} from "@angular/forms";
import {ImportadorIfoodService} from "../../services/importador-ifood.service";
import {PainelImportacaoProdutosComponent} from "../painel-importacao-produtos/painel-importacao-produtos.component";
import {ArmazenamentoService} from "../../services/armazenamento.service";
import {ModalKendo} from "../../lib/ModalKendo";
declare var moment;

@Component({
  selector: 'app-tela-sincronizar-ifood',
  templateUrl: './tela-sincronizar-ifood.component.html',
  styleUrls: ['./tela-sincronizar-ifood.component.scss']
})
export class TelaSincronizarIfoodComponent  extends ModalKendo implements OnInit {
  @Input() empresa: any;
  @ViewChild('frm', {static: false}) frm: NgForm;
  @ViewChild('painelImportacao', {static: false}) painelImportacao: PainelImportacaoProdutosComponent;
  catalogo: any = {};
  mensagemSucesso: any;
  mensagemErro: any;
  opcoes: any = { link: null, salvoLink: false};
  buscando = false;
  filtro: any;
  buscarProdutos: boolean
  buscouProdutos: boolean;
  tudoSincronizado: boolean;
  sincronizando: boolean;
  sincronizou: boolean;
  KEYLINKLOJA = '#linklojaifood'
  KEYLINKLOJAANOTAI = '#linklojaifood'
  KEYLINKLOJAOLACLICK = '#linklojaOlaclick'
  KEYLINKLOJACARDAPIOWEB = '#linklojaCardapioWeb'
  KEYLINKSISTEMAEXTERNO = '#linkSistemaExterno'
  KEYS_SISTEMA_EXTERNO: Record<string, string> = {
    ifood:       '#linkSistemaExterno_ifood',
    anotaai:     '#linkSistemaExterno_anotaai',
    olaclick:    '#linkSistemaExterno_olaclick',
    cardapioweb: '#linkSistemaExterno_cardapioweb',
    cardapioai: '#linkSistemaExterno_cardapioai',
    uairango:    '#linkSistemaExterno_uairango',
    instadelivery: '#linkSistemaExterno_instadelivery',
    menudino:    '#linkSistemaExterno_menudino',
    deliverydireto: '#linkSistemaExterno_deliverydireto',
  };
  empresaInfo: any;
  sistemaExterno = false;
  anotaAi = false;
  olaclick = false;
  cardapioWeb = false;
  cardapioAi = false;
  uaiRango = false;
  instaDelivery = false;
  menuDino = false;
  deliveryDireto = false;
  ifoodOficial = false;
  PLATAFORMAS = [
    { id: 'anotaai',     nome: 'Anota Ai',     logo: 'assets/icons/logo-anotaai.png',     placeholder: 'nome-da-sua-loja', prefixo: 'pedido.anota.ai/loja/' },
    { id: 'olaclick',    nome: 'OlaClick',     logo: 'assets/icons/logo-olaclick.png',    placeholder: 'nome-da-sua-loja', prefixo: '', sufixo: '.ola.click' },
    { id: 'cardapioweb', nome: 'Cardápio Web', logo: 'assets/icons/logo-cardapioweb.png', placeholder: 'nome-do-cardapio', prefixo: 'app.cardapioweb.com/' },
    { id: 'cardapioai', nome: 'Cardapio.ai', logo: 'https://cardapio.ai/favicon.ico', placeholder: 'nome-do-cardapio', prefixo: 'cardapio.ai/' },
    { id: 'uairango',    nome: 'UaiRango',     logo: 'https://www.uairango.com/favicon.ico', placeholder: 'nome-da-sua-loja', prefixo: 'uairango.com/' },
    { id: 'instadelivery', nome: 'InstaDelivery', logo: 'assets/icons/logo-instadelivery.jpg', placeholder: 'nome-da-sua-loja', prefixo: 'instadelivery.com.br/' },
    { id: 'menudino',    nome: 'MenuDino',     logo: 'assets/icons/logo-menudino.png', placeholder: 'nome-da-sua-loja', prefixo: '', sufixo: '.menudino.com.br' },
    { id: 'deliverydireto', nome: 'Delivery Direto', logo: 'https://deliverydireto.com.br/favicon.ico', placeholder: 'marca/nome-da-loja', prefixo: 'deliverydireto.com.br/' },
  ];
  PLATAFORMA_IFOOD = { id: 'ifood', nome: 'iFood', logo: 'assets/icons/logo-ifood.png', placeholder: 'nome-da-sua-loja', prefixo: 'ifood.com.br/delivery/' };
  plataformaDetectada: any = null;
  plataformaSelecionada: any = null;
  integracoesIfood: any[] = [];
  catalogosIfood: any[] = [];
  carregandoCatalogos = false;
  carregandoAdicionais = false;
  carregamentoAdicionais: any = {
    totalProdutos: 0,
    totalPaginas: 0,
    paginaAtual: 0,
    totalProcessados: 0,
    finalizado: false
  };
  statusCarregamentoAdicionais = '';
  constructor( private importador:  ImportadorIfoodService,
              private armazenamentoService: ArmazenamentoService) {
    super()

  }

  ngOnInit(): void {
   this.buscarProdutos = true

    if(this.ifoodOficial){
      this.integracoesIfood = (this.empresa && this.empresa.integracoesIfood)
        ? this.empresa.integracoesIfood.filter((item: any) => !item.desativado)
        : [];

      if(this.integracoesIfood.length === 1){
        this.opcoes.idLojaIfood = this.integracoesIfood[0].idLoja;
        this.onMudouIntegracaoIfood();
      }

      return;
    }

    if(this.sistemaExterno){
      // Link carregado por plataforma ao selecionar o card
      return;
    }

    if(this.cardapioWeb){
      let linkCardapioWeb = this.armazenamentoService.carregue(this.KEYLINKLOJACARDAPIOWEB, false)
      if(linkCardapioWeb) this.opcoes.link = this.extraiaNomeLoja(linkCardapioWeb, this.PLATAFORMAS.find(p => p.id === 'cardapioweb'))
    } else if(this.olaclick){
      let linkOlaclick = this.armazenamentoService.carregue(this.KEYLINKLOJAOLACLICK, false)
      if(linkOlaclick) this.opcoes.link = this.extraiaNomeLoja(linkOlaclick, this.PLATAFORMAS.find(p => p.id === 'olaclick'))
    } else if(!this.anotaAi){
      if(this.catalogo && this.catalogo.lojaIfood){
        this.opcoes.link = this.extraiaNomeLoja(this.catalogo.lojaIfood, this.PLATAFORMA_IFOOD);
      } else {
        let linkIfood = this.armazenamentoService.carregue(this.KEYLINKLOJA, false)

        if(linkIfood)
          this.opcoes.link = this.extraiaNomeLoja(linkIfood, this.PLATAFORMA_IFOOD);

      }
    } else {
      let linkAnotai = this.armazenamentoService.carregue(this.KEYLINKLOJAANOTAI, false)

      if(linkAnotai) this.opcoes.link = this.extraiaNomeLoja(linkAnotai, this.PLATAFORMAS.find(p => p.id === 'anotaai'))
    }


  }

  obtenhaNomeFonteImportacao() {
    if(this.plataformaDetectada) return this.plataformaDetectada.nome;
    if(this.cardapioWeb) return 'Cardápio Web';
    if(this.cardapioAi) return 'Cardapio.ai';
    if(this.uaiRango) return 'UaiRango';
    if(this.deliveryDireto) return 'Delivery Direto';
    if(this.olaclick) return 'Olaclick';
    if(this.anotaAi) return 'Anota Ai';

    return 'Ifood';
  }

  detectePlataforma(url: string): any {
    if(!url) return null;
    const urlLower = url.toLowerCase().trim();

    if(urlLower.includes('.ola.click') || urlLower.includes('olaclick'))
      return this.PLATAFORMAS.find(p => p.id === 'olaclick');

    if(urlLower.includes('anota.ai') || urlLower.includes('anotaai'))
      return this.PLATAFORMAS.find(p => p.id === 'anotaai');

    if(urlLower.includes('cardapio.ai'))
      return this.PLATAFORMAS.find(p => p.id === 'cardapioai');

    if(urlLower.includes('cardapioweb') || urlLower.includes('meucardapio'))
      return this.PLATAFORMAS.find(p => p.id === 'cardapioweb');

    if(urlLower.includes('uairango.com') || urlLower.includes('uairango'))
      return this.PLATAFORMAS.find(p => p.id === 'uairango');

    if(urlLower.includes('instadelivery'))
      return this.PLATAFORMAS.find(p => p.id === 'instadelivery');

    if(urlLower.includes('menudino'))
      return this.PLATAFORMAS.find(p => p.id === 'menudino');

    if(urlLower.includes('deliverydireto'))
      return this.PLATAFORMAS.find(p => p.id === 'deliverydireto');

    if(urlLower.includes('ifood'))
      return this.PLATAFORMA_IFOOD;

    return null;
  }

  selecionePlataforma(plataforma: any) {
    if(this.plataformaSelecionada?.id === plataforma.id) return;
    this.plataformaSelecionada = plataforma;
    this.plataformaDetectada = plataforma;
    this.anotaAi = plataforma.id === 'anotaai';
    this.olaclick = plataforma.id === 'olaclick';
    this.cardapioWeb = plataforma.id === 'cardapioweb';
    this.cardapioAi = plataforma.id === 'cardapioai';
    this.uaiRango = plataforma.id === 'uairango';
    this.instaDelivery = plataforma.id === 'instadelivery';
    this.menuDino = plataforma.id === 'menudino';
    this.deliveryDireto = plataforma.id === 'deliverydireto';
    const linkSalvo = this.armazenamentoService.carregue(this.KEYS_SISTEMA_EXTERNO[plataforma.id], false);
    this.opcoes.link = linkSalvo ? this.extraiaNomeLoja(linkSalvo, plataforma) : null;
    delete this.mensagemErro;
  }

  onUrlChanged() {
    if(!this.sistemaExterno) return;
    const detectada = this.detectePlataforma(this.opcoes.link);
    if(detectada && detectada.id !== this.plataformaSelecionada?.id) {
      this.plataformaSelecionada = detectada;
      this.plataformaDetectada = detectada;
      this.anotaAi = detectada.id === 'anotaai';
      this.olaclick = detectada.id === 'olaclick';
      this.cardapioWeb = detectada.id === 'cardapioweb';
      this.cardapioAi = detectada.id === 'cardapioai';
      this.uaiRango = detectada.id === 'uairango';
      this.instaDelivery = detectada.id === 'instadelivery';
      this.menuDino = detectada.id === 'menudino';
      this.deliveryDireto = detectada.id === 'deliverydireto';
    }
  }

  extraiaNomeLoja(link: string, plataforma: any): string {
    if(!link) return link;
    // Remove protocolo e query string
    let limpo = link.replace(/https?:\/\/(www\.)?/, '').split('?')[0].replace(/\/+$/, '').trim();
    if(plataforma?.sufixo) {
      // Formato subdomínio: nome.menudino.com → nome
      return limpo.split('.')[0];
    }
    // Formato path: dominio.com/caminho/slug → slug (último segmento)
    const partes = limpo.split('/');
    if(plataforma?.id === 'deliverydireto' && partes.length >= 3)
      return partes.slice(-2).join('/');

    return partes[partes.length - 1].trim();
  }

  obtenheLinkCompleto(): string {
    const nome = this.opcoes.link?.trim();
    if(!nome || !this.plataformaSelecionada) return nome;
    const p = this.plataformaSelecionada;
    if(nome.includes('://') || nome.includes('.com') || nome.includes('.ai')) return nome;
    if(p.sufixo) return `https://${nome}${p.sufixo}`;
    if(p.prefixo) return `https://${p.prefixo}${nome}`;
    return nome;
  }

  linkCopiado = false;

  copiarLink() {
    const link = this.obtenheLinkCompleto();
    if(link) {
      navigator.clipboard.writeText(link);
      this.linkCopiado = true;
      setTimeout(() => this.linkCopiado = false, 2000);
    }
  }

  onPasteLink(event: ClipboardEvent) {
    const texto = event.clipboardData?.getData('text')?.trim();
    if(!texto) return;
    // Detecta plataforma pelo link colado
    const detectada = this.detectePlataforma(texto);
    if(detectada) {
      event.preventDefault();
      if(detectada.id !== this.plataformaSelecionada?.id) {
        this.selecionePlataforma(detectada);
      }
      this.opcoes.link = this.extraiaNomeLoja(texto, detectada);
    }
  }

  usaFluxoIfoodAntigo() {
    if(this.sistemaExterno) return this.plataformaDetectada?.id === 'ifood';
    return !this.anotaAi && !this.ifoodOficial && !this.olaclick && !this.cardapioWeb && !this.cardapioAi && !this.uaiRango && !this.instaDelivery && !this.menuDino && !this.deliveryDireto;
  }

  fecheMensagemErro() {
    delete this.mensagemErro;
  }

  fecheMensagemSucesso() {
    delete this.mensagemSucesso;
  }

  feche() {
    this.fecheModal(this.painelImportacao.importou)
  }

   async onBusqueProdutos() {
    if(this.buscando) return;

    delete this.mensagemErro;
    delete this.mensagemSucesso;
    delete this.tudoSincronizado;
    this.statusCarregamentoAdicionais = '';

    this.buscando = true;

    let resposta: any, keyBusca: string;

    if(this.sistemaExterno){
      if(!this.plataformaSelecionada){
        this.buscando = false;
        this.mensagemErro = 'Selecione uma plataforma antes de buscar.';
        return;
      }
      keyBusca = this.KEYS_SISTEMA_EXTERNO[this.plataformaSelecionada.id];
    }

    if(this.cardapioWeb){
      if(!keyBusca) keyBusca = this.KEYLINKLOJACARDAPIOWEB;
      resposta = await this.importador.listeNovosProdutosCardapioWeb(this.obtenheLinkCompleto(), this.opcoes.reducao,
        this.opcoes.sincronizarPrecos, this.opcoes.sincronizarImagens).catch( erro => {
        this.buscando = false;
        this.mensagemErro = erro;
      });
    } else if(this.cardapioAi){
      if(!keyBusca) keyBusca = this.KEYS_SISTEMA_EXTERNO.cardapioai;
      resposta = await this.importador.listeNovosProdutosCardapioAi(this.obtenheLinkCompleto(), this.opcoes.reducao,
        this.opcoes.sincronizarPrecos, this.opcoes.sincronizarImagens).catch( erro => {
        this.buscando = false;
        this.mensagemErro = erro;
      });
    } else if(this.uaiRango){
      if(!keyBusca) keyBusca = this.KEYS_SISTEMA_EXTERNO.uairango;
      resposta = await this.importador.listeNovosProdutosUaiRango(this.obtenheLinkCompleto(), this.opcoes.reducao,
        this.opcoes.sincronizarPrecos, this.opcoes.sincronizarImagens).catch( erro => {
        this.buscando = false;
        this.mensagemErro = erro;
      });
    } else if(this.instaDelivery){
      if(!keyBusca) keyBusca = this.KEYS_SISTEMA_EXTERNO.instadelivery;
      resposta = await this.importador.listeNovosProdutosInstaDelivery(this.obtenheLinkCompleto(), this.opcoes.reducao,
        this.opcoes.sincronizarPrecos, this.opcoes.sincronizarImagens).catch( erro => {
        this.buscando = false;
        this.mensagemErro = erro;
      });
    } else if(this.menuDino){
      if(!keyBusca) keyBusca = this.KEYS_SISTEMA_EXTERNO.menudino;
      resposta = await this.importador.listeNovosProdutosMenuDino(this.obtenheLinkCompleto(), this.opcoes.reducao,
        this.opcoes.sincronizarPrecos, this.opcoes.sincronizarImagens).catch( erro => {
        this.buscando = false;
        this.mensagemErro = erro;
      });
    } else if(this.deliveryDireto){
      if(!keyBusca) keyBusca = this.KEYS_SISTEMA_EXTERNO.deliverydireto;
      resposta = await this.importador.listeNovosProdutosDeliveryDireto(this.obtenheLinkCompleto(), this.opcoes.reducao,
        this.opcoes.sincronizarPrecos, this.opcoes.sincronizarImagens).catch( erro => {
        this.buscando = false;
        this.mensagemErro = erro;
      });
    } else if(this.olaclick){
      if(!keyBusca) keyBusca = this.KEYLINKLOJAOLACLICK;
      resposta = await this.importador.listeNovosProdutosOlaclick(this.obtenheLinkCompleto(), this.opcoes.reducao, this.opcoes.sincronizarPrecos,
        this.opcoes.sincronizarImagens).catch( erro => {
        this.buscando = false;
        this.mensagemErro = erro;
      });
    } else if(this.anotaAi){
      if(!keyBusca) keyBusca = this.KEYLINKLOJAANOTAI;
      resposta = await this.importador.listeNovosProdutosAnotaAi(this.obtenheLinkCompleto(), this.opcoes.reducao, this.opcoes.sincronizarPrecos,
        this.opcoes.sincronizarImagens).catch( erro => {
        this.buscando = false;
        this.mensagemErro = erro;
      });
    } else {
      if(this.ifoodOficial){
        if(!this.opcoes.idLojaIfood || !this.opcoes.idCatalogoIfood){
          this.buscando = false;
          this.mensagemErro = 'Selecione a integração iFood e o catálogo oficial.';
          return;
        }

        resposta = await this.importador.listeNovosProdutosIfoodOficial(this.opcoes.idLojaIfood, this.opcoes.reducao,
          this.opcoes.sincronizarPrecos,
          this.opcoes.sincronizarImagens, this.opcoes.idCatalogoIfood).catch( erro => {
          this.buscando = false;
          this.mensagemErro = erro;
        });
      } else {
        if(!keyBusca) keyBusca = this.KEYLINKLOJA;
        resposta = await this.importador.listeNovosProdutosIfood(this.obtenheLinkCompleto(), this.opcoes.reducao, this.opcoes.sincronizarPrecos,
          this.opcoes.sincronizarImagens).catch( erro => {
          this.buscando = false;
          this.mensagemErro = erro;
        });
      }
    }

    if(resposta){
      this.buscouProdutos = true;
      this.empresaInfo   = resposta.empresaInfo;
      if(resposta.novosProdutos.length || resposta.produtosAtualizar.length){
        this.buscarProdutos = false;
        this.painelImportacao.setProdutosSincronizar(resposta.novosProdutos, resposta.produtosAtualizar, [],
          resposta.categorias)

        if(this.usaFluxoIfoodAntigo()){
          await this.carregueAdicionaisIfood(resposta.novosProdutos, resposta.produtosAtualizar);
        }
      } else {
        this.tudoSincronizado = true;
      }

      this.buscando = false;
      if(keyBusca)
        this.armazenamentoService.salveSemExpirar(keyBusca, this.obtenheLinkCompleto())
    }
  }

  onFilter(texto: any){

  }

  obtenhaFormatoPercentual(){
    return String(`0"%"`);
  }

  sincronizarTodos() {

  }

  shakePlataforma = false;
  shakeLink = false;
  erroValidacao = '';

  validarEBuscar() {
    this.erroValidacao = '';
    this.shakePlataforma = false;
    this.shakeLink = false;

    if(this.sistemaExterno && !this.plataformaSelecionada) {
      this.erroValidacao = 'Selecione uma plataforma';
      this.shakePlataforma = true;
      setTimeout(() => this.shakePlataforma = false, 500);
      return;
    }

    if(!this.ifoodOficial && !this.opcoes.link?.trim()) {
      this.erroValidacao = 'Informe o link da sua loja';
      this.shakeLink = true;
      setTimeout(() => this.shakeLink = false, 500);
      return;
    }

    this.submitFormBusca();
  }

  submitFormBusca() {
    this.frm.ngSubmit.emit()
  }

  importouProdutoDoIfood($event: any) {
    if(!this.opcoes.salvoLink && this.usaFluxoIfoodAntigo()){
      this.importador.salveLinkIfod(this.obtenheLinkCompleto()).then(() => {
        this.opcoes.salvoLink = true;
      });
    }
  }

  private async carregueAdicionaisIfood(novosProdutos: any[], produtosAtualizar: any[]) {
    const tamanhoPagina = 20;
    let todosProdutos = [...(novosProdutos || []), ...(produtosAtualizar || [])];
    let produtosComNeedChoices = todosProdutos.filter((produto: any) => produto && produto.needChoices && produto.idIfood);
    let idsUnicos = Array.from(new Set(produtosComNeedChoices.map((produto: any) => String(produto.idIfood))));

    if(!idsUnicos.length){
      this.carregandoAdicionais = false;
      this.carregamentoAdicionais = {
        totalProdutos: 0,
        totalPaginas: 0,
        paginaAtual: 0,
        totalProcessados: 0,
        finalizado: true
      };
      this.atualizeIndicadoresAdicionais();
      return;
    }

    this.carregandoAdicionais = true;
    this.statusCarregamentoAdicionais = 'Buscando adicionais para importar...';
    this.carregamentoAdicionais = {
      totalProdutos: idsUnicos.length,
      totalPaginas: Math.ceil(idsUnicos.length / tamanhoPagina),
      paginaAtual: 0,
      totalProcessados: 0,
      finalizado: false
    };

    for(let i = 0; i < idsUnicos.length; i += tamanhoPagina){
      let idsPagina = idsUnicos.slice(i, i + tamanhoPagina);
      this.carregamentoAdicionais.paginaAtual = Math.floor(i / tamanhoPagina) + 1;

      let carregouPagina = false;
      while(!carregouPagina){
        let resposta: any

        if(this.ifoodOficial){
          resposta =  await  this.importador.listeAdicionaisIfoodOficial(
            this.opcoes.idLojaIfood,
            idsPagina,
            this.opcoes.reducao,
            this.opcoes.idCatalogoIfood
          )
            .catch((erro: any) => {
              return this.deuErro(erro);
            });
        } else {
          resposta =  await  this.importador.listeAdicionaisProdutosIfood(this.obtenheLinkCompleto(), idsPagina, this.opcoes.reducao)
            .catch((erro: any) => {
              return this.deuErro(erro);
            });
        }

        if(!resposta){
          await this.sleep(5000);
          continue;
        }

        if(resposta && resposta.produtos){
          resposta.produtos.forEach((produtoComAdicional: any) => {
            let produto = todosProdutos.find((item: any) => String(item.idIfood) === String(produtoComAdicional.idIfood));
            if(produto)
              produto.camposAdicionais = produtoComAdicional.camposAdicionais || [];
          })
        }

        this.statusCarregamentoAdicionais = 'Buscando adicionais para importar...';
        carregouPagina = true;
      }

      this.carregamentoAdicionais.totalProcessados += idsPagina.length;
      this.atualizeIndicadoresAdicionais();

      let naoEhUltimaPagina = (i + tamanhoPagina) < idsUnicos.length;
      if(naoEhUltimaPagina)
        await this.sleep(8000);
    }

    this.carregandoAdicionais = false;
    this.carregamentoAdicionais.finalizado = true;
    this.statusCarregamentoAdicionais = '';
    this.atualizeIndicadoresAdicionais();
  }

  private deuErro(erro: any) {
    let detalhe = erro && erro.message ? erro.message : erro;
    this.mensagemErro = detalhe;
    this.statusCarregamentoAdicionais =
      `Lentidão na página ${this.carregamentoAdicionais.paginaAtual}/${this.carregamentoAdicionais.totalPaginas}. ` +
      `Tentar novamente da aqui a pouco... Vai demorar um pouco mais que previsto, aguarde e não feche essa tela.`;
    return null;
  }

  private atualizeIndicadoresAdicionais() {
    if(!this.painelImportacao || !this.painelImportacao.produtosSincronizarPorCategoria) return;

    this.painelImportacao.produtosSincronizarPorCategoria.forEach((categoria: any) => {
      categoria.produtos.forEach((produto: any) => {
        if(produto.sincronizar){
          const campos = produto.camposAdicionais || [];
          produto.qtdeAdicionaisNovos = campos.filter((adicional: any) => !adicional.id).length;
          produto.qtdeAdicionaisAtualizar = campos.filter((adicional: any) => adicional.id != null).length;
        }
      })
    })
  }

  private sleep(ms: number){
    return new Promise((resolve: any) => setTimeout(resolve, ms));
  }

  obtenhaPercentualCarregamentoAdicionais(){
    if(!this.carregamentoAdicionais || !this.carregamentoAdicionais.totalProdutos) return 0;
    return Math.round((this.carregamentoAdicionais.totalProcessados / this.carregamentoAdicionais.totalProdutos) * 100);
  }

  async onMudouIntegracaoIfood() {
    this.opcoes.idCatalogoIfood = null;
    this.catalogosIfood = [];
    if(!this.opcoes.idLojaIfood) return;

    this.carregandoCatalogos = true;
    delete this.mensagemErro;

    let catalogos: any[] = await this.importador.listeCatalogosIfoodOficial(this.opcoes.idLojaIfood).catch((erro) => {
      this.mensagemErro = erro;
      this.carregandoCatalogos = false;
    });

    if(catalogos){
      this.catalogosIfood = catalogos.map((catalogo: any) => {
        let descricao = catalogo.name  || catalogo.type || catalogo.context || catalogo.id;

        if(catalogo.modifiedAt)
            descricao = ` ${descricao} - Ultima alteraçao: ${moment(new Date(catalogo.modifiedAt)).format('DD/MMM/YY HH:mm')}`

        return { id: catalogo.catalogId, descricao: descricao};
      });

      if(this.catalogosIfood.length === 1)
        this.opcoes.idCatalogoIfood = this.catalogosIfood[0].id;
    }

    this.carregandoCatalogos = false;
  }
}
